import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/clock.svg';

export const IconClock = createIconComponent(Icon);
